import React from 'react';
import { Typography, Box, Link } from '@mui/material';

export default function EmassDashboard() {

return (
    <>
        <Box sx={{display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',}}>
            <Typography zIndex={'1'}>
                <Link href='./pmOverview' underline="none">PM Overview </Link> 
                | <Link href='./issoOverview' underline="none">ISSO/ISSM Overview </Link>
                | <Link href='./enterpriseOverview' underline="none">Enterprise Overview </Link>  
                | <Link href='./aoScorecard' underline="none">AO Scorecard </Link> 
                | <Link href='./roadmap' underline="none">Implementation Roadmap </Link>
                | <Link href='./aoOversight' underline="none">AO Oversight View </Link>
                | <Link href='./systemOverview' underline="none">System Details </Link>
                | <Link href='./trending' underline="none">Trending </Link>       
            </Typography>
        </Box>  
    </>
)
}